import { render, staticRenderFns } from "./DetailDialogRowItem.vue?vue&type=template&id=f15e8076&lang=pug&"
import script from "./DetailDialogRowItem.vue?vue&type=script&lang=js&"
export * from "./DetailDialogRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports